import React, { Component } from 'react';
import Login from './pages/login/Login';
import Survey from './pages/survey/Survey';

class App extends Component {
  state = {
    login: false
  };

  componentDidMount() {
    window.init();
    var addScript = document.createElement('script');
    addScript.setAttribute('src', '/js/functions.js');
    document.body.appendChild(addScript);
  }

  handleAuth = () => {
    this.setState({ login: true });
  };
  render() {
    return (
      <div>
        {this.state.login ? <Survey /> : <Login handleAuth={this.handleAuth} />}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js